module.exports = __webpack_public_path__ + "static/media/bgEtiqaNew.0fa1c45c.png";